import React, { useEffect, useState } from "react";
import { AppApprovalPoints, VendorTypeData } from "../../../constants/AppConstants";
import { SCF_ALLOWED_COMPANY_CODES } from "../../../constants/AppConstants";
import VisibilityIcon from "@mui/icons-material/Visibility";
import useStyles from "./SapVendorSearch.css";
import translation from "../../../i18n/i18.json";
import { VendorRequestAction } from "../../../constants/AppConstants";
import {
  Button,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import { Company } from "../../../models/Company";
import AllActions from "../../../actions";
import {
  InforDisplyaDuration,
  VendorForm1Modes,
  NavigationPaths,
  VendorRequestViewMode,
} from "../../../constants/AppConstants";
import { useDispatch } from "react-redux";
import { ResponseObject } from "../../../models/ResponseObject";
import { SAPVendor } from "../../../models/SAPVendor";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { VendorMasterData } from "../../../services/VendorMasterData";
import { any } from "video.js/dist/types/utils/events";
import { ApprovalPointUtil } from "../../../utils/ApprovalPointUtil";

interface SapVendorSearchProp {
  //handleClose: any;
  //open: boolean;
  //title: string;
  isEditmode: boolean;
  companyCode?: string;
  // companyCodeList: Array<Company>;
  //selectedVendorCompanies : Array<SAPVendor>;
  onVendorSelect: any;
  alreadySelectedVendors: string[];
  nodataMsg: string;
  maxSelectItems?: number;
  ignoreVendors?: string[];
}

interface VendorSearchParams {
  companyCode: string;
  vendorName: string;
  vendorNo: string;
}

// interface ChipData {
//   key: number;
//   label: string;
// }

export default function SapVendorSearch(props: SapVendorSearchProp) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    isEditmode,
    companyCode,
    onVendorSelect,
    alreadySelectedVendors,
    nodataMsg,
    maxSelectItems,
    ignoreVendors,
  } = props;
  const initialState: VendorSearchParams = {
    companyCode: "",
    vendorName: "",
    vendorNo: "",
  };
  const [filterParams, setFilterParams] = useState(initialState);
  const [vendorListItems, setVendorListItems] = useState<SAPVendor[]>([]);
  const [isTableLoading, setIsTableLoading] = React.useState(false);

  const tableColumnData = Array<any>();

  if (isEditmode) {
    tableColumnData.splice(0, 0, { name: "" });
    tableColumnData.push({ name: translation.vendordetail_vendor_select_popup_cocode });
    tableColumnData.push({ name: translation.vendordetail_vendor_select_popup_poCode });
    tableColumnData.push({ name: translation.vendordetail_vendor_select_popup_sapvendorno });
    tableColumnData.push({ name: translation.vendordetail_vendor_select_popup_country });
    tableColumnData.push({ name: translation.vendordetail_vendor_select_popup_vendorname });
  } else {
    tableColumnData.push({ name: translation.vendordetail_vendor_select_popup_sapvendorno });
  }

  //const [chipData, setChipData] = React.useState<ChipData[]>([]);
  const [selectedVendors, setSelectedVendors] = React.useState<SAPVendor[]>([]);
  //const [selectedVendorCompanies, setSelectedVendorCompanies] = React.useState<SAPVendor[]>([]);

  const prepareForRequest = () => {
    dispatch(AllActions.backDropActions.openBackDrop());
  };
  const isScfAllowed = (companyCode: string): boolean => {
    return SCF_ALLOWED_COMPANY_CODES.includes(companyCode);
  };
  const compeleteRequest = (
    success: boolean,
    message?: string,
    duration?: number
  ) => {
    dispatch(AllActions.backDropActions.closeBackDrop());
    if (message) {
      let messageduration = duration ? duration : InforDisplyaDuration.common;
      if (success) {
        dispatch(
          AllActions.infoActions.openInforSuccess(message, messageduration!)
        );
      } else {
        dispatch(
          AllActions.infoActions.openInforError(message, messageduration!)
        );
      }
    }
  };

  const handleChange = (input: string) => (e: any) => {
    let val: any = e.target.value;
    setFilterParams({ ...filterParams!, [input]: val });
  };

  const handleFilter = (e: any) => {
    if (filterParams.vendorNo === "" && filterParams.vendorName === "") {
      dispatch(AllActions.infoActions.openInforWarn(translation.vendordetail_vendor_select_popup_filtrrquired_msg, InforDisplyaDuration.common));
      return;
    } else if (
      filterParams.vendorNo === "" &&
      filterParams.vendorName !== "" &&
      filterParams.vendorName.length < 2
    ) {
      dispatch(
        AllActions.infoActions.openInforWarn(
          translation.vendordetail_vendor_select_popup_filtrvendorname_len_msg,
          InforDisplyaDuration.common
        )
      );
      return;
    }
    setIsTableLoading(true);
  };

  useEffect(() => {
    if (isTableLoading) {
      getVendorList();
    }
  }, [isTableLoading]);

  useEffect(() => {
    if(selectedVendors && selectedVendors.length > 0){
      let clusterCodes = selectedVendors.map(v => v.clusterCode);
      let relatedVendorCompanies = vendorListItems
        .filter(v => selectedVendors.find(sv => sv.vendor == v.vendor));
      if(onVendorSelect){
        onVendorSelect(selectedVendors, relatedVendorCompanies);
      }
    }
  }, [selectedVendors]);

  const getVendorList = () => {
    prepareForRequest();
    setVendorListItems([]);
    VendorMasterData.GetSAPVendorList(
      {
        companyCode: filterParams!.companyCode,
        vendorNo: filterParams!.vendorNo,
        vendorName: filterParams!.vendorName,
      },
      (result: Array<SAPVendor>) => {
        if (result && result.length > 0) {
          let array: Array<SAPVendor> = result;
          //let flags = [],
          let uniqueVendorList = [],
            l = array.length,
            i;
          for (i = 0; i < l; i++) {
            if (ignoreVendors && ignoreVendors.length > 0
              && ignoreVendors.indexOf(array[i].vendor) > -1) {
              continue;
            }
            uniqueVendorList.push(array[i]);
          }
          setVendorListItems(uniqueVendorList);
          //set state
          dispatch({
            type: "ON_CHANGE_VENDOR_SEARCH_DATA",
            payload: uniqueVendorList,
          });
          compeleteRequest(true);
        } else {
          setVendorListItems([]);
          compeleteRequest(
            false,
            translation.vendordetail_vendor_select_popup_nodata_err
          );
        }
        setIsTableLoading(false);
      },
      (error) => {
        compeleteRequest(
          false,
          translation.vendordetail_vendor_select_popup_data_searcerr
        );
        setIsTableLoading(false);
        setVendorListItems([]);
      }
    );
  };

  const handleChipDelete = (chipToDelete: SAPVendor) => () => {
    setSelectedVendors(
      selectedVendors.filter((row) => {
        return !(chipToDelete.vendor === row.vendor && chipToDelete.compCode === row.compCode);
      })
    );
    //onVendorSelect(selectedVendors);
    //onVendorSelect([selectedVendors], [selectedVendorCompanies]);
    //setChipData((chips) => chips.filter((chip) => chip.key !== chipToDelete.sapVendorNo));
  };


  const deriveAllowedActionsFromRow = (row: SAPVendor): VendorRequestAction[] => {
    const actions: VendorRequestAction[] = [];

    // AMEND
    if (row.isUserPermittedCompany) {
      actions.push(VendorRequestAction.AMEND);
    }

    // EXTEND
    if (!row.isBlockAllCompay &&
      !row.isBlockSelectedCompany &&
      !row.isBlockSelectedPurchOrg &&
      !row.isBlockAllPurchOrg) {
      actions.push(VendorRequestAction.EXTEND);
    }

    // BLOCK
    if (row.isUserPermittedCompany) {
      actions.push(VendorRequestAction.BLOCK);
    }

    // INDIVIDUAL PAY
    if (
      isScfAllowed(row.compCode) &&
      (row.vendorTypeCode === VendorTypeData.RMProductionRelated ||
        row.vendorTypeCode === VendorTypeData.AffiliatedVendorsWithinMAS) &&
      ApprovalPointUtil.isUserPermitedApprovalPoint(row.compCode, [AppApprovalPoints.VInvVendorInitial])
    ) {
      actions.push(VendorRequestAction.INDIVIDUAL_PAY);
    }

    return actions;
  };

  const getAllowedActions = (row: SAPVendor) => {
    const actions: VendorRequestAction[] = [];

    if (row.canView) {
      actions.push(VendorRequestAction.VIEW);
    }

    if (row.canAmend) {
      actions.push(VendorRequestAction.AMEND);
    }

    if (row.canExtend) {
      actions.push(VendorRequestAction.EXTEND);
    }

    if (row.canBlock) {
      actions.push(VendorRequestAction.BLOCK);
    }

    if (row.canIndividualPay) {
      actions.push(VendorRequestAction.INDIVIDUAL_PAY);
    }

    return actions;
  };

  const handleViewClick = (row: SAPVendor) => {
    const allowedActions = deriveAllowedActionsFromRow(row);

    console.log("Derived actions (grid parity):", allowedActions);

    const queryParams = new URLSearchParams({
      mode: VendorRequestViewMode.VendorView.toString(),
      sapVendorNo: row.vendor,
      companyCode: row.compCode,
      poCodes: row.poCodes?.join(",") ?? "",
      isView: "false",                     // ✅ allow buttons
      actions: allowedActions.join(","),   // ✅ SAME AS GRID
    }).toString();

    window.open(`/VendorRequest?${queryParams}`, "_blank");
  };

  const handleTableRowClick = (event: React.MouseEvent<unknown>, selectedVendor: SAPVendor) => {
    const isVendorExists = selectedVendors.find((row) => {
        return selectedVendor.vendor === row.vendor && selectedVendor.compCode === row.compCode;
      }) ? true : false;

    if (!isVendorExists && maxSelectItems && selectedVendors.length === maxSelectItems ) {
      dispatch(AllActions.infoActions.openInforWarn(
          `${translation.vendordetail_vendor_select_popup_slectedmax_msg} ${maxSelectItems}`,
          InforDisplyaDuration.common ));
      return;
    }

    if (isVendorExists) {
      setSelectedVendors(
        selectedVendors.filter((row) => {
          return !(selectedVendor.vendor === row.vendor && selectedVendor.compCode === row.compCode);
        })
      );
    } else {
      setSelectedVendors([...selectedVendors, selectedVendor]);
    }

    const compCode = selectedVendor.compCode?.toString().trim().toLowerCase();
    const clusterCode =
      vendorListItems
        ?.find(r => r.compCode?.toString().trim().toLowerCase() === compCode)
        ?.clusterCode;

    // const relatedCompanies = vendorListItems.filter(row =>
    //   row.clusterCode?.toString().trim().toLowerCase() === clusterCode?.toString().trim().toLowerCase()
    // );
    //setSelectedVendorCompanies(relatedCompanies);
    //selected action
    //onVendorSelect([selectedVendor], relatedCompanies);
  };

  const isItemSelected = (item: SAPVendor) => {
    const selectedIndex = selectedVendors.findIndex((row) => {
      return item.vendor === row.vendor && item.compCode === row.compCode;
    });

    return selectedIndex !== -1 ? true : false;
  };

  return (
    <div>
      <Grid className={classes.NoPopWrapper} container>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          {isEditmode && (
            <Grid container spacing={1} direction="row">
              {filterParams.companyCode && (
                <Grid item xs={12} sm={4} md={4} lg={4}>
                  <div>
                    <span className={classes.popUpLBL}>
                      {translation.vendordetail_vendor_select_popup_cocode}
                    </span>
                    <div className={classes.inputWrapper_Req}>
                      <span className={classes.textWrap}>
                        {filterParams.companyCode}
                      </span>
                    </div>
                  </div>
                </Grid>)}
              <Grid item xs={12} sm={4} md={4} lg={4}>
                <div style={{ textAlign: "start" }}>
                  <span className={classes.popUpLBL}>
                    {
                      translation.vendordetail_vendor_select_popup_sapvendorno
                    }
                  </span>
                  <div className={classes.inputWrapper}>
                    <TextField
                      variant="outlined"
                      value={filterParams.vendorNo}
                      onChange={handleChange("vendorNo")}
                    ></TextField>
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={4} md={4} lg={4}>
                <div style={{ textAlign: "start" }}>
                  <span className={classes.popUpLBL}>
                    {
                      translation.vendordetail_vendor_select_popup_vendorname
                    }
                  </span>
                  <div className={classes.inputWrapper}>
                    <TextField
                      variant="outlined"
                      value={filterParams.vendorName}
                      onChange={handleChange("vendorName")}
                    ></TextField>
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={4} md={4} lg={4}>
                <div className={classes.searchBtnWrapper}>
                  <Button onClick={handleFilter}>
                    <SearchIcon></SearchIcon>
                    {translation.dashboard_filternm_btntxt}
                  </Button>
                </div>
              </Grid>
            </Grid>
          )}
          {isEditmode && (
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Paper component="ul" className={classes.chiproot}>
                {selectedVendors && selectedVendors.length > 0
                  ? selectedVendors.map((data) => {
                    return (
                      <li key={data.vendor + data.compCode}>
                        <Chip
                          label={data.vendor + "(" + data.compCode + ")"}
                          onDelete={handleChipDelete(data)}
                          className={classes.chip}
                        />
                      </li>
                    );
                  })
                  : nodataMsg}
              </Paper>
            </Grid>
          )}
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <div className={classes.tblOuterBG}>
              <Paper>
                <TableContainer className={classes.tblContainer}>
                  <Table
                    size="small"
                    stickyHeader
                    aria-label="sticky table"
                    style={{ minWidth: "100px" }}
                  >
                    <TableHead className={classes.tblHeader}>
                      <TableRow>
                        {tableColumnData.map((column, index) => {
                          return column.name === "" ? (
                            <TableCell>{column.name}</TableCell>
                          ) : (
                            <TableCell style={{ minWidth: "100px" }}>
                              {column.name}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    </TableHead>
                    <TableBody className={classes.tblBody}>
                      {vendorListItems &&
                        vendorListItems.map((row, i) => {
                          return (
                            <TableRow
                              key={row.vendor}
                              onClick={(event) =>
                                handleTableRowClick(event, row)
                              }
                            >
                              <Checkbox
                                checked={isItemSelected(row)}
                              ></Checkbox>
                              <TableCell>{row.compCode}</TableCell>
                              <Tooltip title={row.poCodes.join(',')}>
                                <TableCell>{row.poCodes.join(',').substring(0, 10)}</TableCell>
                              </Tooltip>
                              <TableCell>{row.vendor}</TableCell>
                              <TableCell>{row.country}</TableCell>
                              <TableCell>{row.vendorName}</TableCell>

                              < TableCell align="center">
                                <IconButton
                                  size="small"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleViewClick(row);
                                  }}
                                >
                                  <VisibilityIcon />
                                </IconButton>
                              </TableCell>

                            </TableRow>
                          );
                        })}
                      {!isEditmode &&
                        selectedVendors &&
                        selectedVendors.map((row, i) => {
                          return (
                            <TableRow key={row.vendor}>
                              <TableCell>{row.vendor}</TableCell>
                            </TableRow>
                          );
                        })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Paper>
            </div>
          </Grid>
        </Grid>
      </Grid>
      {/* <div style={{ margin: "18px 25px 0 0px" }}>
            <div style={{ margin: "20px ​10px 15px 0" }}>
              {isEditmode && (
                <div className={classes.greenBtnWrapper}>
                  <Button onClick={handleConfirm} color="primary">
                    <CheckCircleIcon></CheckCircleIcon>
                    {translation.vendordetail_vendor_select_popup_ok_btn}
                  </Button>
                </div>
              )}
              <div className={classes.grayBtnWrapper}>
                <Button onClick={handleClose} color="primary" autoFocus>
                  {translation.vendordetail_vendor_select_popup_close_btn}
                </Button>
              </div>
            </div>
        </div> */}
    </div>
  );
}
